import { useCallback, useContext } from 'react';
import { useUserInfo } from './useUserInfo';
import memoizeOne from 'react-utils/memoizeOne';
import { ApprovalScopeOverrideContext } from '../context/approvalScopeOverrideContext';

const EMPTY_SCOPES = new Set<string>();

/*
 * scopes don't change over the lifetime of the app. use a memoized helper to
 * ensure that all calls to the `useGetHasScope` hook share one Set,
 * instead of each hook call/component building its own.
 *
 * Copied from customer-data-properties. This can be replaced when this lib is quartz exclusive.
 */
const memoizedToScopesSet = memoizeOne((scopes: string[]) => new Set(scopes));

export const useGetHasScope = () => {
  const overrideScopes = useContext(ApprovalScopeOverrideContext);
  const userInfo = useUserInfo();

  const scopes =
    overrideScopes === undefined
      ? !userInfo || !userInfo.user
        ? EMPTY_SCOPES
        : memoizedToScopesSet(userInfo.user.scopes)
      : memoizedToScopesSet(overrideScopes);

  return useCallback((scope: string) => scopes.has(scope), [scopes]);
};
